import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

// Make sure TypeScript interface includes all properties you're using
declare global {
    interface Window {
      firebase?: {
        auth: any;
        db: any;
        app: any;
        functions: any;
        storage: any;
      };
    }
  }
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY?.replace(/"/g, '') ,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN?.replace(/"/g, '') ,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID?.replace(/"/g, '') ,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET?.replace(/"/g, '') ,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID?.replace(/"/g, '') ,
    appId: process.env.REACT_APP_FIREBASE_APP_ID?.replace(/"/g, '')  ,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID?.replace(/"/g, '') 
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);

// Initialize Firestore with a specific database ID
// For Firebase v9, the database ID is the third parameter
export const db = getFirestore(app, 'seektrudb');

export const functions = getFunctions(app);
export const storage = getStorage(app);

// Enable detailed firebase logging in development
if (process.env.NODE_ENV === 'development') {
    // @ts-ignore
    window.firebase = { 
      auth, 
      db, 
      app, 
      functions, 
      storage 
    };

    console.log('Firebase initialized with config:', {
        ...firebaseConfig,
        apiKey: '[HIDDEN FOR SECURITY]',
        databaseId: 'seektrudb' // Log for debugging
      });
  }


export default app;